export default function convertPoundsToPence(pounds = 0) {
  return pounds * 100;
}
